import { Record, RecordOf } from 'immutable';

export type PreferenceDataType = 'STRING' | 'NUMBER' | 'BOOLEAN' | 'JSON' | 'ARRAY';
export type PreferenceType = 'USER' | 'SYSTEM';
export type PreferenceScope = 'DATASET' | 'USER';
export type PreferenceV2Props = {
  clientId?: string;
  id?: string; // same as name - use it as a key (real qcs id is in preferenceId)
  isDeleted?: boolean;
  preferenceType?: PreferenceType;
  name?: string;
  dataType?: PreferenceDataType;
  label?: string;
  value?: any;
  createdAt?: string;
  modifiedAt?: string;
  scope?: PreferenceScope;
  preferenceId?: string; // real qcs id (we abuse 'id' = 'name' to use it as a key for convenience)
};
export type PreferenceV2 = RecordOf<PreferenceV2Props>;

export const mkPreferenceV2 = Record<PreferenceV2Props>({
  clientId: undefined,
  id: undefined,
  isDeleted: undefined,
  preferenceType: undefined,
  name: undefined,
  dataType: undefined,
  label: undefined,
  value: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
  scope: undefined,
  preferenceId: undefined,
});

export type PreferenceCriteriaProps = {
  clientId?: string;
  id?: string;
  isDeleted?: boolean;
  preferenceName?: string;
  value?: any;
  rollOutTarget?: string[];
  criteriaType?: string;
  rollOutType?: string;
  client?: string;
  datasetPlatform?: string;
};
export type PreferenceCriteria = RecordOf<PreferenceCriteriaProps>;
export const mkPreferenceCriteria = Record<PreferenceCriteriaProps>({
  clientId: undefined,
  id: undefined,
  isDeleted: undefined,
  preferenceName: undefined,
  value: undefined,
  rollOutTarget: undefined,
  criteriaType: undefined,
  rollOutType: undefined,
  client: undefined,
  datasetPlatform: undefined,
});
